/// <amd-module name="Feed/Legacy/Utils/Upstream" />
import { findIndex } from "OfficeFabric/Utilities";

import * as Utils_String from "VSS/Core/Util/String";

import { IHubState } from "Feed/Legacy/Types/IHubState";
import { UpstreamSource_All, UpstreamSource_Local } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

import { UpstreamSource } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";

export function urlSourceToUpstreamSource(hubState: IHubState, upstreamSources: UpstreamSource[]): UpstreamSource {
    const sourceKey = hubState.upstreamSource;
    switch (sourceKey) {
        case null:
            return null;
        case PackageResources.UpstreamSourceKey_All:
            return UpstreamSource_All;
        case PackageResources.UpstreamSourceKey_Local:
            return UpstreamSource_Local;
        case PackageResources.UpstreamSourceKey_Cache /* for legacy when npmjs was the only upstream source */:
            return upstreamSources[0];
    }

    if (hubState.protocolType == null) {
        const stringEvaluationCallback = (upstreamSource, source) =>
            Utils_String.equals(upstreamSource.name, source, true);
        return sourceKeyToUpstreamSource(sourceKey, upstreamSources, stringEvaluationCallback);
    }

    const protocolStringEvaluationCallback = (upstreamSource, source) =>
        Utils_String.equals(Utils_String.format("{0},{1}", upstreamSource.protocol, upstreamSource.name), source, true);
    return sourceKeyToUpstreamSource(
        Utils_String.format("{0},{1}", hubState.protocolType, sourceKey),
        upstreamSources,
        protocolStringEvaluationCallback
    );
}

export function sourceKeyToUpstreamSource(
    source: string,
    upstreamSources: UpstreamSource[],
    getStringEvaluation: (upstreamSource: UpstreamSource, source: string) => boolean
): UpstreamSource {
    if (upstreamSources == null || upstreamSources.length === 0) {
        return null;
    }

    const index: number = findIndex(upstreamSources, (upstreamSource: UpstreamSource) => {
        return getStringEvaluation(upstreamSource, source);
    });

    if (index > -1) {
        return upstreamSources[index];
    }

    return null;
}
